import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../services/api";
import yandexLogo from "../assets/logo.png";

const RegisterPage = ({ onLogin }) => {

    const navigate = useNavigate();

    const [step, setStep] = useState(1);

    const [formData, setFormData] = useState({
        company_type: "",
        company_name: "",
        phone: "",
        full_name: "",
        email: "",
        password: ""
    });

    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const selectType = (type) => {
        setFormData({
            ...formData,
            company_type: type
        });
    };

    // =========================
    // VALIDATION
    // =========================

    const isStep1Valid =
        formData.company_type &&
        formData.company_name.trim() &&
        formData.phone.trim();

    const isStep2Valid =
        formData.full_name.trim() &&
        formData.email.trim() &&
        formData.password.trim();

    // =========================
    // YANDEX
    // =========================

    const handleYandexLogin = async () => {
        try {

            if (!isStep1Valid) {
                setError("Заполните данные компании перед входом через Яндекс");
                return;
            }

            localStorage.setItem(
                "register_profile",
                JSON.stringify({
                    company_type: formData.company_type,
                    company_name: formData.company_name,
                    phone: formData.phone,
                    email: formData.email
                })
            );

            const response = await auth.yandexLogin();
            window.location.href = response.data.auth_url;

        } catch {
            setError("Ошибка входа через Яндекс");
        }
    };

    // =========================
    // SUBMIT
    // =========================

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!isStep2Valid) {
            setError("Заполните все поля");
            return;
        }

        setLoading(true);
        setError("");

        try {

            await auth.register(formData);

            const loginResponse = await auth.login({
                email: formData.email,
                password: formData.password
            });

            const { access_token } = loginResponse.data;

            localStorage.setItem("token", access_token);

            const userResponse = await auth.getMe();

            onLogin(userResponse.data, access_token);

            navigate("/");

        } catch (err) {

            const detail = err.response?.data?.detail;

            if (Array.isArray(detail)) {
                setError(detail[0].msg);
            } else {
                setError(detail || "Ошибка регистрации");
            }

        } finally {
            setLoading(false);
        }
    };

    // =========================
    // UI
    // =========================

    return (

        <div className="auth-wrapper">

            <div className="auth-card">

                <h2 className="auth-title">
                    Регистрация
                </h2>

                {error && <div className="error">{error}</div>}

                {/* =========================
                    STEP 1
                ========================= */}
                {step === 1 && (

                    <div className="auth-form">

                        <div className="role-switch">

                            <button
                                type="button"
                                className={`role-btn ${formData.company_type === "customer" ? "active" : ""}`}
                                onClick={() => selectType("customer")}
                            >
                                Заказчик
                            </button>

                            <button
                                type="button"
                                className={`role-btn ${formData.company_type === "supplier" ? "active" : ""}`}
                                onClick={() => selectType("supplier")}
                            >
                                Поставщик
                            </button>

                        </div>

                        <input
                            name="company_name"
                            className="form-input"
                            placeholder="Название компании"
                            value={formData.company_name}
                            onChange={handleChange}
                        />

                        <input
                            name="phone"
                            className="form-input"
                            placeholder="Телефон"
                            value={formData.phone}
                            onChange={handleChange}
                        />

                        <button
                            className="btn-primary"
                            disabled={!isStep1Valid}
                            onClick={() => { setError(""); setStep(2); }}
                        >
                            Продолжить
                        </button>

                        <div className="auth-link">
                            Уже есть аккаунт? <span className="auth-link-btn" onClick={() => navigate("/login")}>Войти</span>
                        </div>

                    </div>

                )}

                {/* =========================
                    STEP 2
                ========================= */}
                {step === 2 && (

                    <form className="auth-form" onSubmit={handleSubmit}>

                        <button
                            type="button"
                            className="auth-back-btn"
                            onClick={() => { setError(""); setStep(1); }}
                            title="Назад"
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
                        </button>

                        <input
                            name="full_name"
                            className="form-input"
                            placeholder="Ваше имя"
                            value={formData.full_name}
                            onChange={handleChange}
                        />

                        <input
                            type="email"
                            name="email"
                            className="form-input"
                            placeholder="Email"
                            value={formData.email}
                            onChange={handleChange}
                        />

                        <input
                            type="password"
                            name="password"
                            className="form-input"
                            placeholder="Пароль"
                            value={formData.password}
                            onChange={handleChange}
                        />

                        <button
                            className="btn-primary"
                            disabled={!isStep2Valid || loading}
                        >
                            {loading ? "Создание..." : "Создать аккаунт"}
                        </button>

                        <div className="divider">
                            <span>или</span>
                        </div>

                        <button
                            type="button"
                            className="yandex-btn"
                            onClick={handleYandexLogin}
                        >
                            <img src={yandexLogo} alt="Yandex" className="yandex-icon" />
                            Войти через Яндекс
                        </button>

                        <div className="auth-link">
                            Уже есть аккаунт? <span className="auth-link-btn" onClick={() => navigate("/login")}>Войти</span>
                        </div>

                    </form>

                )}

            </div>

        </div>

    );
};

export default RegisterPage;